module.exports = __webpack_public_path__ + "static/media/ideas.f5b83e8c.svg";